import { DateField, TextField } from "react-admin";

import Card from "./Card";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { group: highlightedGroupIds = [] } = useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedGroupIds.includes(id)) return "modifyResource";
    return "";
  };

  return (
    <ResponsiveList
      {...props}
      type="table"
      split
      perPage={10}
      filters={<Filters />}
      key={highlightedGroupIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        rowBreakpoint="sm"
        cardContent={<Card />}
        target="group"
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <TextField source="code" variant="body2" />
        <TextField source="name" />
        <DateField source="modified" showTime />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default List;
